// @ts-nocheck
import { BoxV2, mixins } from 'sonata-react-components';
import styled from 'styled-components';

type Props = {
  isFootfallAttrMap: boolean;
};

export const MapSectionStyled = styled.div`
  .reportingMapsSection {
    &__title {
      width: 100%;
      display: flex;
      align-items: center;
      margin-right: 12px;
    }
  }
`;

export const MapContainerStyled = styled(BoxV2)<Props>`
  overflow-x: scroll;
  ${mixins.forceScrollbar};
  ${props => (props.isFootfallAttrMap ? 'margin-bottom: 40px;' : '')};

  .mapContainer {
    &__boxBody {
      display: flex;
      justify-content: stretch;
    }

    &__mapsContainer {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }

    &__maps {
      display: flex;
      width: 100%;
    }
  }
`;
